import { NavLink } from 'react-router-dom';

function ProductFilter() {
    return (
       <>
          <div className="col-lg-3 col-md-4 col-sm-7 col-xs-12 pull-left">
                <div className="service-single-sidebar">
                    {/* <!--Start single sidebar--> */}
         <div className="single-sidebar">
                        <ul className="service-lists">
                            {/* <li className="allservice"><NavLink to="/indusref-products">View All Services<i className="fa fa-cog" aria-hidden="true"></i></NavLink></li> */}
                            <li><NavLink to="/industrial-refrigeration">Skid Mounted Refpacks</NavLink></li>
                            <li><NavLink to="/cooling-and-chilling">Process Chillers and Coolers</NavLink></li>
                            <li><NavLink to="/heat-pumps">Heat Pumps</NavLink></li>
                            <li><NavLink to="/ICE-production-systems">ICE Production systems</NavLink></li>
                            <li><NavLink to="/ammonia-recirculator-package">Ammonia Recirculator Package</NavLink></li>
                            <li><NavLink to="/cooling-condenser">Cooling Condenser</NavLink></li>
                            <li><NavLink to="/pressure-vessels">Pressure Vessels</NavLink></li>
                               <li><NavLink to="/freezers">Freezers</NavLink></li>
                              <li><NavLink to="/control-systems">Control Systems</NavLink></li>
                            <li><NavLink to="/support-services">Support Services</NavLink></li>
                        </ul>
                    </div>
             {/* <!--End single sidebar--> */}
                    {/* <!--Start single sidebar--> */}
                  
                     </div>
            </div>          
                    {/* <!--Scroll to top--> */}
                    {/* <div className="scroll-to-top scroll-to-target" data-target="html"><span className="fa fa-angle-up"></span></div> */}

       </>
    )
}


export default ProductFilter;